import * as colors from "../../constants/colors";
import * as languages from "../../constants/languages";
import { css, StyleSheet } from "aphrodite";
import { english, spanish } from "../../constants/strings";
import loginStyles from "../../styles/loginStyles";
import Link from "react-router/lib/Link";
import LoggedOutPage from "../LoggedOutPage";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

const styles = StyleSheet.create({
	link: {
		textDecoration: "none",
		color: colors.black4,
	},
	message: {
		marginTop: 12,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		fontSize: 15,
		lineHeight: 1.33,
		color: colors.black4,
		paddingLeft: 14,
		paddingRight: 20,
		textAlign: "center",
	},
});

export default class ThankYouPage extends PureComponent {
	static propTypes = {
		language: PropTypes.string.isRequired,
		pathname: PropTypes.string.isRequired,
		redirectPath: PropTypes.string,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;
	}

	render() {
		const { language } = this.props;
		const { redirectPath } = this.props;
		return (
			<LoggedOutPage
				pageTitle={this.strings.thanksForSigningUp}
				language={this.props.language}
				currentRoute={this.props.pathname}
			>
				<div className={css(loginStyles.buttonContainer)}>
					{/* eslint-disable-next-line */}
					<Link
						to={
							redirectPath && redirectPath !== "undefined"
								? { pathname: redirectPath, query: { language } }
								: { pathname: "catalog", query: { language } }
						}
						className={css(styles.link)}
					>
						<button className={css(loginStyles.button)}>{this.strings.CONTINUE}</button>
					</Link>
				</div>
			</LoggedOutPage>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/ThankYouPage.js